import { render, staticRenderFns } from "./jls_report.vue?vue&type=template&id=2bb7c682&scoped=true"
import script from "./jls_report.vue?vue&type=script&lang=js"
export * from "./jls_report.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb7c682",
  null
  
)

export default component.exports